<template>
    <div id="file-upload">
        <div :class="`file-align-${align}`">
            <h3 @click="focusFieldLabel" v-if="!editingFieldLabel">{{ displayFieldLabel }}</h3>
            <input
                v-if="editingFieldLabel"
                type="text"
                class="field-label-input"
                placeholder="Dosya Yükle"
                v-model="localFieldLabelFile"
                @blur="stopEditingFieldLabel"
                @keydown.enter="stopEditingFieldLabel"
                ref="fieldLabelInput"
            />
            <div>
                <div class="upload-container">
                    <input type="file" :id="`file-input-${fieldId}`" class="file-input" @change="handleFileUpload" multiple>
                    <label :for="`file-input-${fieldId}`" class="file-label">
                        <div class="upload-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                <polyline points="7,10 12,15 17,10"/>
                                <line x1="12" y1="15" x2="12" y2="3"/>
                            </svg>
                        </div>
                        <div class="upload-text">
                            <p class="upload-title">{{ altLabelOne || 'Dosya seçiniz' }}</p>
                            <p class="upload-subtitle">{{ altLabelTwo || 'Dosya seçiniz' }}</p>
                        </div>
                    </label>
                </div>
            </div>
            <div class="file-list" v-if="files.length > 0">
                <div v-for="(file, index) in files" :key="index" class="file-item">
                    <div class="file-preview-container">
                        <img :src="file.preview" class="file-preview" />
                    </div>
                    <div class="file-info">
                        <span class="file-name">{{ file.name }}</span>
                        <span class="file-size">{{ formatFileSize(file.raw && file.raw.size) }}</span>
                    </div>
                    <button class="delete-button" @click="removeFile(index)" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M3 6h18"/>
                            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "FileUpload",
    props: {
        item: Object,
        fieldLabelFile: String,
        align: String,
        altLabelOne: String,
        altLabelTwo: String,
    },
    data() {
        return {
            localFieldLabelFile: this.fieldLabelFile || "",
            localAlign: this.align || "",
            localAltLabelOne: this.altLabelOne || "",
            localAltLabelTwo: this.altLabelTwo || "",
            files: [],
            fileUrls: [],
            editingFieldLabel: false,
            fieldId: 'file-upload-' + Math.random().toString(36).substr(2, 9),
        };
    },
    computed: {
        displayFieldLabel() {
            return this.localFieldLabelFile || "Dosya Yükle";
        },
    },
    methods: {
        focusFieldLabel() {
            this.editingFieldLabel = true;
            this.$nextTick(() => {
                if (this.$refs.fieldLabelInput) {
                    this.$refs.fieldLabelInput.focus();
                }
            });
        },
        stopEditingFieldLabel() {
            this.editingFieldLabel = false;
        },
        formatFileSize(bytes) {
            if (!bytes) return '';
            const k = 1024;
            const sizes = ['B', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
        },
        handleFileUpload(event) {
            const newFiles = Array.from(event.target.files).map(file => ({
                name: file.name,
                preview: file.name.endsWith('.pdf') ? 'https://static.supsis.live/common/image/PDFICON.png' : URL.createObjectURL(file),
                raw: file,
                _id: null,
                asset: null,
                fieldId: this.fieldId
            }));
            this.files = [...this.files, ...newFiles];
        },
        removeFile(index) {
            URL.revokeObjectURL(this.files[index].preview);
            this.files.splice(index, 1);
        },
    },
};
</script>
<style lang="scss" scoped>
#file-upload {
    width: 100%;
    max-width: 700px;
    margin: clamp(0.5rem, 1.5vw, 1rem) auto;
    padding: clamp(0.625rem, 1.5vw, 0.875rem);
    background: linear-gradient(145deg,
        rgba(255, 255, 255, 0.02) 0%,
        rgba(255, 255, 255, 0.01) 100%);
    border-radius: 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.06);
    transition: all 0.3s ease;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

    &:hover {
        background: linear-gradient(145deg,
            rgba(255, 255, 255, 0.03) 0%,
            rgba(255, 255, 255, 0.02) 100%);
    }

    h3 {
        font-size: clamp(0.95rem, 2.2vw, 1.1rem);
        font-weight: 600;
        margin: 0 0 clamp(0.5rem, 1.2vw, 0.75rem) 0;
        color: rgba(55, 65, 81, 0.9);
        line-height: 1.4;
        cursor: pointer;
    }

    .field-label-input {
        font-size: clamp(0.95rem, 2.2vw, 1.1rem);
        font-weight: 600;
        margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        color: rgba(55, 65, 81, 0.9);
        line-height: 1.4;
        border: none;
        background: transparent;
        outline: none;
        border-bottom: 2px solid #f26a52;
        padding: 0 0 2px 0;

        &::placeholder {
            color: rgba(156, 163, 175, 0.7);
        }
    }

    .upload-container {
        border: 2px dashed rgba(209, 213, 219, 0.6);
        border-radius: clamp(0.5rem, 1.5vw, 0.75rem);
        padding: clamp(1.5rem, 4vw, 2rem) clamp(1rem, 3vw, 1.5rem);
        background: rgba(255, 255, 255, 0.4);
        backdrop-filter: blur(8px);
        transition: all 0.3s ease;
        position: relative;
        cursor: pointer;

        &:hover {
            border-color: #f26a52;
            background: rgba(255, 255, 255, 0.6);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(242, 106, 82, 0.15);
        }

        .file-input {
            display: none;
        }

        .file-label {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: clamp(0.75rem, 2vw, 1rem);
            cursor: pointer;

            .upload-icon {
                width: clamp(2.5rem, 6vw, 3rem);
                height: clamp(2.5rem, 6vw, 3rem);
                color: #f26a52;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(242, 106, 82, 0.1);
                border-radius: 50%;
                transition: all 0.3s ease;

                svg {
                    width: clamp(1.25rem, 3vw, 1.5rem);
                    height: clamp(1.25rem, 3vw, 1.5rem);
                }
            }

            .upload-text {
                text-align: center;

                .upload-title {
                    font-size: clamp(0.875rem, 2vw, 1rem);
                    font-weight: 600;
                    color: rgba(55, 65, 81, 0.9);
                    margin: 0 0 clamp(0.25rem, 0.5vw, 0.375rem) 0;
                    line-height: 1.4;
                }

                .upload-subtitle {
                    font-size: clamp(0.8rem, 1.8vw, 0.875rem);
                    color: rgba(107, 114, 128, 0.8);
                    margin: 0;
                    line-height: 1.4;
                }
            }
        }

        &:hover .upload-icon {
            background: rgba(242, 106, 82, 0.15);
            transform: scale(1.05);
        }
    }

    .file-list {
        margin-top: clamp(0.75rem, 2vw, 1rem);
        display: flex;
        flex-direction: column;
        gap: clamp(0.5rem, 1.2vw, 0.75rem);

        .file-item {
            display: flex;
            align-items: center;
            gap: clamp(0.5rem, 1.2vw, 0.75rem);
            padding: clamp(0.75rem, 2vw, 1rem);
            background: rgba(255, 255, 255, 0.6);
            border: 1px solid rgba(226, 232, 240, 0.8);
            border-radius: clamp(0.375rem, 1vw, 0.5rem);
            transition: all 0.3s ease;

            &:hover {
                background: rgba(255, 255, 255, 0.8);
                border-color: #f26a52;
                transform: translateX(4px);
            }

            .file-preview-container {
                flex-shrink: 0;
                width: clamp(2.5rem, 6vw, 3rem);
                height: clamp(2.5rem, 6vw, 3rem);
                border-radius: clamp(0.375rem, 1vw, 0.5rem);
                overflow: hidden;
                background: rgba(248, 250, 252, 0.9);
                border: 1px solid rgba(226, 232, 240, 0.8);

                .file-preview {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s ease;
                }
            }

            .file-info {
                flex: 1;
                min-width: 0;
                display: flex;
                flex-direction: column;
                gap: clamp(0.125rem, 0.3vw, 0.25rem);

                .file-name {
                    font-size: clamp(0.8rem, 1.8vw, 0.875rem);
                    font-weight: 500;
                    color: rgba(55, 65, 81, 0.9);
                    line-height: 1.4;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .file-size {
                    font-size: clamp(0.7rem, 1.5vw, 0.75rem);
                    color: rgba(107, 114, 128, 0.8);
                    line-height: 1.3;
                }
            }

            .delete-button {
                flex-shrink: 0;
                width: clamp(2rem, 4.5vw, 2.25rem);
                height: clamp(2rem, 4.5vw, 2.25rem);
                border: none;
                background: transparent;
                color: rgba(107, 114, 128, 0.7);
                border-radius: clamp(0.25rem, 0.6vw, 0.375rem);
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.3s ease;

                svg {
                    width: clamp(1rem, 2.2vw, 1.125rem);
                    height: clamp(1rem, 2.2vw, 1.125rem);
                }

                &:hover {
                    background: rgba(239, 68, 68, 0.1);
                    color: #ef4444;
                    transform: scale(1.1);
                }
            }

            &:hover .file-preview {
                transform: scale(1.05);
            }
        }
    }
}

/* Alignment Classes */
.file-align-left {
    display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);

    h3 {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: left;
    }

    .field-label-input {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: left;
    }

    > div {
        flex: 1;
        min-width: 0;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0;

        h3, .field-label-input {
            width: 100%;
            text-align: left;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
            padding-top: 0;
        }

        > div {
            width: 100%;
        }
    }
}

.file-align-right {
    display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);

    h3 {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: right;
    }

    .field-label-input {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: right;
    }

    > div {
        flex: 1;
        min-width: 0;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0;

        h3, .field-label-input {
            width: 100%;
            text-align: left;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
            padding-top: 0;
        }

        > div {
            width: 100%;
        }
    }
}

@media (max-width: 768px) {
    #file-upload {
        margin: clamp(0.25rem, 1vw, 0.5rem) auto;
        padding: clamp(0.5rem, 1.2vw, 0.75rem);

        .upload-container {
            padding: clamp(1.25rem, 3vw, 1.5rem) clamp(0.75rem, 2vw, 1rem);

            .file-label {
                gap: clamp(0.625rem, 1.5vw, 0.75rem);

                .upload-icon {
                    width: clamp(2.25rem, 5vw, 2.5rem);
                    height: clamp(2.25rem, 5vw, 2.5rem);

                    svg {
                        width: clamp(1.125rem, 2.5vw, 1.25rem);
                        height: clamp(1.125rem, 2.5vw, 1.25rem);
                    }
                }
            }
        }

        .file-list {
            .file-item {
                padding: clamp(0.625rem, 1.5vw, 0.75rem);
                gap: clamp(0.375rem, 1vw, 0.5rem);

                .file-preview-container {
                    width: clamp(2.25rem, 5vw, 2.5rem);
                    height: clamp(2.25rem, 5vw, 2.5rem);
                }
            }
        }
    }
}

@media (prefers-reduced-motion: reduce) {
    #file-upload, .upload-container, .file-item, .upload-icon, .file-preview, .delete-button {
        transition: none;
    }

    .upload-container:hover, .file-item:hover {
        transform: none;
    }

    .upload-container:hover .upload-icon, .file-item:hover .file-preview, .delete-button:hover {
        transform: none;
    }
}
</style>
